
export const blue ="#64D8E0";
export const blue_Opacity50 ="#64D8E01F";
export const SemiWhite = "#F5F5F5";
export const DarkBlue = '#2B324A';
export const White = "#FFFFFF";
export const Pink = "#E383AA"